<div class="container pb-3">
  <div class="row">
    <h2 class="mt-2 mb-1 d-flex justify-content-between align-items-center">
      Solo
      <svg class="svgbtn bi bi-sliders" width="25" height="25" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z"/>
      </svg>
    </h2>
    <div class="col collapse bg-2" id="collapseExample">
      <div class="row">
        <hr>
        <h3 class="col-12">Settings</h3>
        <div class="col-12 col-md-auto mb-3">
          <label for="targetChange" class="form-label">Target score</label>
          <input type="number" (blur)="targetChange($event)" value="{{ game.targetScore }}" class="form-control form-control-lg" id="targetChange">
        </div>

        <div class="col-12 col-md-auto mb-3">
          <label for="setsChange" class="form-label">Amount of sets</label>
          <input type="number" (blur)="setsChange($event)" value="{{ game.maxSets }}" class="form-control form-control-lg" id="setsChange">
        </div>

        <div class="col-12 col-md-auto mb-3">
          <label for="setsChange" class="form-label">Add/remove players</label>
          <div class="form-control p-0 border-0">
            <div class="btn-group col-12" role="group" aria-label="Button group with nested dropdown">
              <button (click)="removePlayer()" class="{{ (players.length === 1) ? 'd-none' : 'btn btn-lg btn-danger' }}">
                <b>-</b>
              </button>
              <button (click)="addPlayer()" class="{{ (players.length === 10) ? 'd-none' : 'btn btn-lg btn-success' }}">
                <b>+</b>
              </button>
            </div>
          </div>
          <label class="form-label">Current number of players: {{ players.length }}</label>
        </div>

        <div class="col-12 col-md-auto mb-3">
          <label for="setsChange" class="form-label">Reset points, bags, sets, bets to start a new round with the same players.</label>
          <div class="">
            <button (click)="resetPoints()" class="btn btn-primary">
              Start new game
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"/>
                <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"/>
              </svg>
            </button>
          </div>
        </div>

        <div class="col-12 col-md-auto mb-3">
          <label for="setsChange" class="form-label">Clear local storage game data</label>
          <div class="">
            <button (click)="resetLocalStorage()" class="btn btn-danger">
              Reset 
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <h1 class="col-12 text-center">
      <span style="font-weight: 800;">{{ game.round }}</span>
      <span>{{ (game.round === 1) ? 'st' : ''}}{{ (game.round === 2) ? 'nd' : ''}}{{ (game.round === 3) ? 'rd' : ''}}{{ (game.round > 3) ? 'th' : ''}}</span>
      <span style="display: block; font-size: 50%">ROUND</span>
    </h1>
  </div>
  <div class="row">
    <div
      class="col-12 col-md-6 col-lg-4 mb-2 mb-md-0 py-4 px-4"
      *ngFor="let player of players">
      <p class="row">
        <span class="col-auto">{{ player.points }}</span>
        <app-player-name class="col-auto" [player]="player"></app-player-name>
      </p>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col">
              <label for="roundBet{{ player.id }}" class="form-label">Sets bet</label>
              <input disabled type="number" (blur)="betChange(player, $event)" value="{{ player.bet }}" class="form-control" id="roundBet{{ player.id }}">
            </div>
            <div class="col-auto btn-group-vertical">
              <button (click)="playerBet(player, 'add')" *ngIf="player.bet !== game.maxSets" type="button" class="btn btn-sm btn-success"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16"><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/></svg></button>
              <button (click)="playerBet(player, 'remove')" *ngIf="player.bet > 0" type="button" class="btn btn-sm btn-danger"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash" viewBox="0 0 16 16"><path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/></svg></button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="col">
              <label for="roundPoints{{ player.id }}" class="form-label">Won sets</label>
              <input disabled type="number" (blur)="setChange(player, $event)" value="{{ player.sets }}" class="form-control" id="roundSets{{ player.id }}">
            </div>
            <div class="col-auto btn-group-vertical">
              <button (click)="playerSets(player, 'add')" *ngIf="player.sets !== game.maxSets" type="button" class="btn btn-sm btn-success"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16"><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/></svg></button>
              <button (click)="playerSets(player, 'remove')" *ngIf="player.sets > 0" type="button" class="btn btn-sm btn-danger"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash" viewBox="0 0 16 16"><path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/></svg></button>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-items-center py-1">
        <span class="col-auto">Quick bet: </span>
        <button (click)="quickBetClick(player, $event)" class="col-auto mx-1 btn btn-primary" *ngFor="let quickBet of game.quickBets" value="{{quickBet}}">{{ quickBet }}</button>
      </div>
    </div>
  </div>
  <div class="row pt-3">
    <span class="col-6 pb-3" style="text-align: right;">Bets: {{ game.roundBets }} / {{ game.maxSets }}</span>
    <span class="col-6 pb-3" style="text-align: left;">Sets: {{ game.roundSets }} / {{ game.maxSets }}</span>
    <div class="col-12">
      <button (click)="submitResults()" class="d-flex align-items-center justify-content-center col-12 col-md-6 offset-md-3 btn btn-lg btn-primary">
        Next round <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16"><path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/></svg>
      </button>
    </div>
  </div>
  <div class="row">
    <app-scoreboard class="col-12" [game]="game" [players]="players"></app-scoreboard>
  </div>
  <div class="row pt-5 mt-5">
    <h3 class="col-12">About Spades</h3>
    <div class="col-12 col-md-auto mb-3">
      <ul>
        <li>If a player gets 10 bags, 100 points will be deducted from the scores and bags turned into 0.</li>
        <br>
        <li>If a player bets 0 and 0 sets are won, the player will be rewarded 100 points.</li>
        <br>
        <li>If a player bets 10 and 10 sets are won, the player will be rewarded 200 points.</li>
      </ul>
    </div>
  </div>
</div>
